var parent = require('../../es/object/get-prototype-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/get-prototype-of.js
// module id = 1020
// module chunks = 0